import React from "react";
import { motion } from "framer-motion";
import FireAlarmImg from "../images/prohome1_1.png";
import NitrogenImg from "../images/prohome1_2.png";
import FoamImg from "../images/prohome1_3.png";
import { Link } from "react-router-dom";

const Products = () => {
  const products = [
    {
      title: "Fire Alarm Systems",
      img: FireAlarmImg,
      link: "/products",
    },
    {
      title: "Nitrogen Gas Fire Suppression System",
      img: NitrogenImg,
      link: "/products",
    },
    {
      title: "Foam Extinguishing Systems",
      img: FoamImg,
      link: "/products",
    },
  ];

  return (
    <section className="relative w-full px-2 lg:px-16 py-16 bg-white">
      {/* Subtle green background highlight */}
      <div className="absolute top-0 left-0 w-full h-1/2 bg-green-50 -z-10" />

      {/* Title */}
      <h2 className="text-2xl md:text-4xl font-semibold text-center text-gray-900 mb-12">
        PRODUCTS
      </h2>

      {/* Product Grid */}
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6">
        {products.map((product, index) => (
          <Link to={product.link} key={index}>
          <motion.div
            key={index}
            className="bg-white shadow-md rounded-xl overflow-hidden border border-gray-200 hover:shadow-2xl transition-all duration-300"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="h-60 overflow-hidden">
              <img
                src={product.img}
                alt={product.title}
                className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="p-6 text-center">
              <h3 className="text-lg font-semibold text-gray-800">
                {product.title}
              </h3>
            </div>
          </motion.div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Products;
